import React, { Component,useParams } from "react";

import Header from "../components/Header/header";
import HeroSection from "../components/HeroSection/HeroSectionDownload";
import DownloadSection from "../components/Download/download";
import FooterSection from "../components/Footer";

function returnParams() {

}
class Theme extends Component {

render() {

    const { params } = this.props.match;
    return (
      <React.Fragment>
        <Header />
        <div className="main">
          <HeroSection />
            <h3>ID: {params.formId}</h3>
          <DownloadSection />
        </div>
        <FooterSection noSubscription={true} />
      </React.Fragment>
    );
  }
}

export default Theme;
